import axios from "@/plugins/axios";
let accordionsSettings = [];

export const apiGetAccordions = async () => {
    try {
        const apiEndPoint = 'accordions';
        const response = await axios.get({ endpoint: '/management/services.v1.homeajax/' + apiEndPoint});
        if(response.data) {
            accordionsSettings = response.data;
            return (accordionsSettings.settings);
        }
    } catch(e) {
        console.log('There has been a problem with your fetch operation: ' + e.message);
    }
    return [];
}

export const apiGetLawlexRecentSearch = async () => {
    try {
        const apiEndPoint = 'getLawlexRecentSearch';
        const response = await axios.post({
            endpoint: '/management/ipd/'+ apiEndPoint,
        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.error('There has been a problem with your fetch operation:'+ e.message);
    }
    return [];
}

export const apiGetLawlexUSSavedSearch = async () => {
    try {
        const apiEndPoint = 'getLawlexUSSavedSearch';
        const response = await axios.post({
            endpoint: '/management/ipd/'+ apiEndPoint,
        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.error('There has been a problem with your fetch operation:'+ e.message);
    }
    return [];
}

export const apiGetEurlexSavedSearch = async () => {
    try {
        const apiEndPoint = 'getEurlexSavedSearch';
        const response = await axios.post({
            endpoint: '/management/ipd/'+ apiEndPoint,
        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.error('There has been a problem with your fetch operation:'+ e.message);
    }
    return [];
}

const apiRedirectToUrl = async (url, module, apiEndPoint) => {
    try {
        const formData = new FormData();
        formData.append('url', url);
        formData.append('module', module);
        const response = await axios.post({
            endpoint: `/management/ipd/${apiEndPoint}`,
            params: formData,
            options: { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
        });
        if (response.data?.success) {
            window.location.href = response.data.redirect;
        }
    } catch (e) {
        console.error('There has been a problem with your fetch operation:' + e.message);
    }
    return [];
};

export const apiRedirectToLawlexUrl = (url, module) =>
    apiRedirectToUrl(url, module, 'redirectToLawlex');

export const apiRedirectToEurlexUrl = (url, module) =>
    apiRedirectToUrl(url, module, 'redirectToEurlex');

export const apiRedirectToLawlexUSUrl = (url, module) =>
    apiRedirectToUrl(url, module, 'redirectToLawlexUS');

export const apiAddToIpdLog = async (moduleName, linkClicked) => {
    try {
        let options = {};
        let params = {};
        options = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
        params = new URLSearchParams();
        params.append('moduleName' , moduleName);
        params.append('linkClicked' , linkClicked);
        const response = await axios.post({
            endpoint: '/management/ipd/addToIpdLog',
            params: params,
            options: options
        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.error('There has been a problem with your fetch operation:'+ e.message);
    }
}

export const apiGetAccordionContent = async(accordionName) => {
    try {
       return accordionsSettings[accordionName] ?? [];
    } catch(e) {
        console.log('There has been a problem with your fetch operation:'+ e.message)
    }
    return [];
}

export const apiGetAccordionFooter = async(accordionName) => {
    try {
        const settings = accordionsSettings.settings;
        const accordionId = settings.filter(setting => {
            return setting.id === accordionName
        })
        return accordionId[0]['footer'] ?? [];
    } catch(e) {
        console.log('There has been a problem with your fetch operation:'+ e.message)
    }
    return [];
}

export const apiUpdateAccordionSettings = async (settings) => {
    try {
        let options = {};
        let params = {};
        options = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
        params = new URLSearchParams();
        params.append('key' , 'home');
        params.append('value' , JSON.stringify(settings));

        const apiEndPoint = 'settings';
        const response = await axios.post({
            endpoint: '/management/services.v1.homeajax/'+ apiEndPoint,
            params: params,
            options: options

        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.log('There has been a problem with your fetch operation:'+ e.message);
    }
    return [];
}

export const deleteSavedSearch = async (elementId) => {
    try {
        const response = await axios.post({
            endpoint: '/management/search/deleteSavedSearch/'+ elementId,
        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.log('There has been a problem with your fetch operation:'+ e.message);
    }
}

export const updateSavedSearch = async (elementId, updatedName, notify) => {
    try {
        let options = {};
        let params = {};
        options = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
        params = new URLSearchParams();
        params.append('name' , updatedName);
        params.append('notify' , notify);
        const response = await axios.post({
            endpoint: '/management/search/editInquiry/'+ elementId,
            params: params,
            options: options
        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.log('There has been a problem with your fetch operation:'+ e.message);
    }
}

export const deleteFavourite = async (report) => {
    try {
        const response = await axios.get({
            endpoint: '/management/reports/unFavourite/' + report,
        });
        if (response.status === 201) {
            return true;
        }
    } catch (e) {
        console.log('There has been a problem when deleting the favourite:' + e.message);
    }
}
